import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActividadesService } from '@services/ofertas-laborales/actividades.service';
import { Actividad } from '@interfaces/interface-bakend/ofertas-laborales/actividad.interface';
import { PerfilesService } from '@services/perfiles/perfiles.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-listado-noticia',
  templateUrl: './listado-noticia.component.html',
  styleUrls: ['./listado-noticia.component.scss']
})
export class ListadoNoticiaComponent implements OnInit {

  /* Data Table*/
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] =
  [
    'nombre', 'vigente' , '_id'
    // 'nombre', 'pais', 'vigente', 'puesto', 'modalidad', 'area' , '_id'
  ];
  dataSource: any;
  ofertas: Actividad [];
  /* Fin Data Table*/

  flagLoaded = false;


  constructor(
      private actividadesService: ActividadesService,
      private router: Router,
      private perfilesService: PerfilesService,
  ) {}

  ngOnInit(): void {
      // this.perfilesService.allowedByUserLogon(this.router.url);
      this.loadDataPage();

  }

  async verActividad(event) {
    const oferta: Actividad = await this.actividadesService.getActividadesFindOne(event);
    this.router.navigateByUrl('/modificacion-noticia');
    await this.actividadesService.setActividadSeleccionada(oferta);
    console.log("clg componente", oferta)
  }

  async loadDataTable() {
    await this.actividadesService.getActividades().then((ofertas: Actividad[]) => {
        console.log('Datos crudos del servicio:', ofertas);
        
        // Filtramos las actividades que SON noticias
        const ofertasFiltradas = ofertas.filter(actividad => {
            // Verificamos si actividadTipo es un objeto y accedemos a su _id
            const tipoId = typeof actividad.actividadTipo === 'object' 
                ? (actividad.actividadTipo as any)?._id 
                : actividad.actividadTipo;
            
            // Solo incluimos las actividades que son noticias
            return tipoId === '679bd689a9a18a04209c41a0';
        });
        
        console.log('Datos filtrados (solo noticias):', ofertasFiltradas);
        
        this.formatDataTable(ofertasFiltradas).then((data: Actividad[]) => {
            this.dataSource = new MatTableDataSource(data);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        });
    });
  }

  formatDataTable( actividad: Actividad[]) {
      return new Promise( resolve => {
        const format: any[] = [];
        let elemento: {
          nombre: string,
          vigente: boolean,
          // puesto: string,
          // modalidad: string,
          // area: string,
          _id: string,
        };
         // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < actividad.length; i++) {
          elemento = {
              nombre: actividad[i].nombre,
              vigente: actividad[i].vigente,
              // puesto: actividad[i].tipoPuesto.concepto,
              // modalidad: actividad[i].modalidad.concepto,
              // area: actividad[i].area.concepto,
              _id: actividad[i]._id,
        };
          format.push(elemento);
        }
        resolve(format);
      });
  }

  applyFilter(event: Event) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async loadDataPage() {
      await this.loadDataTable();
      this.flagLoaded = true;
      return;
  }

  eliminarNoticia(id: string) {
    Swal.fire({
      title: '¿Eliminar noticia?',
      text: 'La noticia será borrada permanentemente.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.actividadesService.delete(id).then(() => {
          Swal.fire('Eliminada', 'La noticia ha sido eliminada.', 'success');
          this.loadDataPage();
        });
      }
    });
  }

}
